module.exports = __webpack_public_path__ + "fonts/af08dbf.otf";